import { Trans, t } from '@lingui/macro';
import { PropTypes } from 'prop-types';
import React from 'react';

const SearchHeading = ({ productName }) => (
  <div className="dhig-theme--light">
    <p className="dhig-typography-headline-medium dhig-mb-2">
      {t`Search the ${productName} knowledge base`}
    </p>
    <p className="body-copy-medium dhig-mb-2 dhig-mt-0">
      <Trans>Find troubleshooting articles to resolve your issue.</Trans>
    </p>
  </div>
);

export default SearchHeading;

SearchHeading.propTypes = {
  productName: PropTypes.string.isRequired
};
